import {
  UPDATE_PROJECT,
} from '../actions/types';

const initialState = {
  difficulty: 'PRO',
  language: 'NL',
  loaded: false,
  EducationProject: {
    nameShort: 'GLXL',
  },
};

const project = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case UPDATE_PROJECT:
      state = {
        ...state,
        ...payload.project,
        loaded: true,
      };
      if (payload.schoolClass && typeof payload.schoolClass.Language === 'object') {
        state.language = payload.schoolClass.Language.code.toUpperCase();
      }
      break;
    default:
      return state
  }
  state.difficulty = state.DefaultDifficultyId === 2 ? 'BASIC' : 'PRO';
  return {...state};
};

export default project;



// WEBPACK FOOTER //
// ./src/reducers/project.js